export default __webpack_public_path__ + "static/media/send.4106dac5.svg";